/**
 * Management accounting reports
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 */


import ApiClient from '../ApiClient';
import FileType from './FileType';





/**
* The SavedFile model module.
* @module model/SavedFile
* @version 1.0.0
*/
export default class SavedFile {
    /**
    * Constructs a new <code>SavedFile</code>.
    * @alias module:model/SavedFile
    * @class
    * @param id {Number} 
    * @param reportId {Number} 
    * @param name {String} 
    * @param type {module:model/FileType} 
    */

    constructor(id, reportId, name, type) {
        

        
        

        this['id'] = id;this['reportId'] = reportId;this['name'] = name;this['type'] = type;

        
    }

    /**
    * Constructs a <code>SavedFile</code> from a plain JavaScript object, optionally creating a new instance.
    * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
    * @param {Object} data The plain JavaScript object bearing properties of interest.
    * @param {module:model/SavedFile} obj Optional instance to populate.
    * @return {module:model/SavedFile} The populated <code>SavedFile</code> instance.
    */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new SavedFile();

            
            
            

            if (data.hasOwnProperty('id')) {
                obj['id'] = ApiClient.convertToType(data['id'], 'Number');
            }
            if (data.hasOwnProperty('reportId')) {
                obj['reportId'] = ApiClient.convertToType(data['reportId'], 'Number');
            }
            if (data.hasOwnProperty('name')) {
                obj['name'] = ApiClient.convertToType(data['name'], 'String');
            }
            if (data.hasOwnProperty('type')) {
                obj['type'] = FileType.constructFromObject(data['type']);
            }
        }
        return obj;
    }

    /**
    * @member {Number} id
    */
    id = undefined;
    /**
    * @member {Number} reportId
    */
    reportId = undefined;
    /**
    * @member {String} name
    */
    name = undefined;
    /**
    * @member {module:model/FileType} type
    */
    type = undefined;








}


